import React from "react";

const data = [
  {
    date: "14 Feb 2023",
    title: "Mobile Theft Prevention using Blockchain",
    description:
      "How can we prevent our mobile phones being stolen?",
    image:
      "https://images.unsplash.com/photo-1643256599406-3aaafc50b380?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=871&q=80",
    href: "https://medium.com/@yathinprakash017/mobile-theft-prevention-using-blockchain-a75736ec9b67",
  },
  {
    date: "14 Mar 2023",
    title: "Research Internship at world's top university",
    description:
      "How I landed my first research internship at the University College London (UCL) in London, UK.",
    image:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/03/Wilkins_Building_1%2C_UCL%2C_London_-_Diliff.jpg/1200px-Wilkins_Building_1%2C_UCL%2C_London_-_Diliff.jpg",
    href: "https://medium.com/@yathinprakash017/research-intern-ucl-a75736ec9b67",
  },
  {
    date: "14 Apr 2023",
    title: "Hadoop 3.3.2 Installation",
    description:
      "How to install Hadoop 3.3.2 on WSL for Big Data Analytics",
    image:
      "https://www.techrepublic.com/wp-content/uploads/2014/02/hadoop.logo.tr.jpg",
    href: "https://medium.com/@yathinprakash017/install-hadoop-3.3.2-wsl-a75736ec9b67",
  },
  // {
  //   date: "18 Nov 2022",
  //   title: "Migrating to Sailboat UI",
  //   description:
  //     "Sailboat UI helps streamline software projects, sprints, tasks, and bug tracking.",
  //   image:
  //     "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80",
  //   to: "/blogs/dual-boot",
  // },
  // {
  //   date: "18 Nov 2022",
  //   title: "Migrating to Sailboat UI",
  //   description:
  //     "Sailboat UI helps streamline software projects, sprints, tasks, and bug tracking.",
  //   image:
  //     "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80",
  //   to: "/blogs/dual-boot",
  // },
  // {
  //   date: "18 Nov 2022",
  //   title: "Migrating to Sailboat UI",
  //   description:
  //     "Sailboat UI helps streamline software projects, sprints, tasks, and bug tracking.",
  //   image:
  //     "https://images.unsplash.com/photo-1552581234-26160f608093?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1000&q=80",
  //   to: "/blogs/dual-boot",
  // },
];

const Blogs = () => {
  return (
    <>
      <div className="flex flex-col text-gray-200">
        <div className="container mx-auto px-6 pt-20 flex-1 text-center">
          <h1 className="text-2xl md:text-4xl lg:text-6xl uppercase">
            Welcome to
          </h1>
          <h2 className="text-3xl md:text-6xl lg:text-8xl uppercase font-black mb-8">
            The Mysterio Blogs
          </h2>
        </div>
      </div>
      <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1 gap-0 px-32">
        {data.map((item) => {
          return (
            <a
              href={item.href}
              class="mx-auto max-w-md overflow-hidden rounded-lg bg-gray-200 shadow scale-90 hover:scale-95 cursor-pointer"
            >
              <img
                src={item.image}
                class="aspect-video w-full object-cover"
                alt="mobile-theft"
              />
              <div class="p-4">
                <p class="mb-1 text-sm text-primary-500">
                  <time>{item.date}</time>
                </p>
                <h3 class="text-xl font-medium text-gray-900">{item.title}</h3>
                <p class="mt-1 text-gray-500">{item.description}</p>
                <div class="mt-4 flex gap-2"></div>
              </div>
            </a>
          );
        })}
      </div>
    </>
  );
};

export default Blogs;
